import ProductBox from '~/themes/base/components/product/ProductBox'

export default {
  extends: ProductBox,
}
